import { lazy } from 'react';

const CharityVettingSearchDetailsEntry = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityVettingSearchDetailsContainer" */ '../containers/CharityVettingSearchDetailsContainer'
    ),
);

export default CharityVettingSearchDetailsEntry;
